import { axiosPath } from "@/axios-path.js";

export default {
  namespaced: true,
  state: {
    addon_list: []
  },
  mutations: {
    resetState(state) {
      state.addon_list = [];
    },
    getAddonList(state, data) {
      state.addon_list = data;
    },
    deleteAddon(state, item) {
      let index = state.addon_list.indexOf(item);
      state.addon_list.splice(index, 1);
    }
  },
  actions: {
    async getVahicelList({ commit, dispatch, rootState }) {
      let url = rootState.api_urls.fetchMessAddonBack_getVahicelList;
      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
        return {};
      } else {
        return res;
      }
    },
    async changeStatusAddon({ commit, dispatch, rootState }, item) {
      let url =
        rootState.api_urls.fetchMessAddonBack_changeStatusAddon + item.addon_id;

      let res = await dispatch(
        "fetchGeneral/axiosPathPutData",
        { url, form: item },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        return true;
      }
    },
    async getAddonDetail({ commit, dispatch, rootState }, item) {
      let url =
        rootState.api_urls.fetchMessAddonBack_getAddonDetail + item.addon_id;
      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
        return {};
      } else {
        return res;
      }
    },
    async editAddon({ commit, dispatch, rootState }, item) {
      let url = rootState.api_urls.fetchMessAddonBack_editAddon + item.addon_id;
      let res = await dispatch(
        "fetchGeneral/axiosPathPutData",
        { url, form: item },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return res;
      } else {
        commit("getAddonList", res.data);
        return "No data available";
      }
    },
    async deleteAddon({ commit, dispatch, rootState }, item) {
      let url =
        rootState.api_urls.fetchMessAddonBack_deleteAddon + item.addon_id;
      let res = await dispatch("fetchGeneral/axiosPathDeleteData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
        return res;
      } else {
        commit("deleteAddon", item);
        return "No data available";
      }
    },
    async addAddon({ commit, dispatch, rootState }, form) {
      let url = rootState.api_urls.fetchMessAddonBack_addAddon;
      let res = await dispatch(
        "fetchGeneral/axiosPathPostData",
        { url, form },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return res;
      } else {
        commit("getAddonList", res);
        return "No data available";
      }
    },
    async getAddonList({ commit, dispatch, rootState }) {
      let url = rootState.api_urls.fetchMessAddonBack_getAddonList;
      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("getAddonList", res);
        return "No data available";
      }
    }
  },
  getters: {}
};
